import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import Table from '../../../../../components/table/Table';
import columns from './columns';
import Button from '../../../../../components/Button';
import { BRAND_PRODUCT_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/brandConstants';
import './BrandDetailProductList.scss';

const BrandDetailProductList = (props) => {
  const { listInfo, getList, getProductSubCategoryList, getBrandDetailProductExcelDownload } = props;
  const { list, filterOption, pagination } = listInfo;

  return (
    <Panel className="brand-detail-product-list">
      <div className="panel-header">
        <div className="title">상품 리스트</div>

        <Button isRadius color="primary" text="엑셀다운" onClick={getBrandDetailProductExcelDownload} />
      </div>

      <div className="panel-body">
        <Table
          data={list}
          isStriped={true}
          emptyText={BRAND_PRODUCT_LIST_TABLE_EMPTY_TEXT}
          showPagination={true}
          filterOption={filterOption}
          pagination={pagination}
          getList={getList}
          columns={(utils) =>
            columns({
              ...utils,
              getProductSubCategoryList,
            })
          }
        />
      </div>
    </Panel>
  );
};

export default BrandDetailProductList;
